import { Component, OnInit, output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-whitelabel-android-google-services-upload',
  templateUrl: './whitelabel-android-google-services-upload.component.html',
  styleUrls: ['./whitelabel-android-google-services-upload.component.css']
})
export class WhitelabelAndroidGoogleServicesUploadComponent implements OnInit {

  public readonly errorEvent$ = output<void>();

  public readonly successEvent$ = output<File>();

  ngOnInit(): void {
  }

  public onGoogleServicesUpload(event: any) {
    const files = event.target.files;
    const uploadedFile = files[0];

    if (uploadedFile) {
      if (uploadedFile.name !== 'google-services.json') {
        this.errorEvent$.emit();
        return;
      }

      this.successEvent$.emit(uploadedFile);
      return;
    }
  }

}
